export enum LoginViewEnum {
  LOADING,
  LOADED,
  LOGIN,
  REGISTRATION,
  FORGOT_PASSWORD,
}
